import WhitePaperProvider from "../provider/WhitePaperProvider";


export default {
    state: {
        file: "",
    },
    getters: {
        getFile: (state) => {
            console.log("getFile", state.file);
            return state.file;
        },
    },
    actions: {
        getWhitePaper({ commit }) {
            WhitePaperProvider.getWhitePaper().then((data) => {
                commit("SET_FILE", data.data.whitePaper[0].file);
            })
        }
    },
    mutations: {
        "SET_FILE"(state, data) {
            state.file = data;
        }
    },

}
